import Status from "../../util/status.js"
import Text from "../text"
import { studentModel } from "./studentModel"
import { trendModel } from "./trendModel"

var expertModel;

var trendDrawing = "";
var currentTrend = null;
const plotScale = {x: 10, y: 50};
const exampleSonification = [{x : 2, y: 30}]

export default {
    resetOtolithPlotting(){
        for (var i = 0; i < studentModel.length; i++){
            studentModel[i].pointLocation = { x: -1, y: -1 };
        }
    },

    getPlotScale(){
        return plotScale;
    },

    getExampleSonificationModel(){
        return exampleSonification;
    },

    getStudentTableModel(){
        var formattedModel = [];
        
        for (var i = 0; i < studentModel.length; i++){
            var otolith = studentModel[i];
            var formatted = {};
            formatted.tag = Text.get(otolith.tag);
            formatted.length = Text.get(otolith.length);
            formatted.age = otolith.age;
            if (otolith.tracingImage !== ''){
                formatted.image = otolith.tracingImage;
            }
            else{
                formatted.image = otolith.image;
            }
            formatted.imageDescription = otolith.thumbnailDescription;
            

            formattedModel.push(formatted);
        }

        return formattedModel;
    },

    getStudentSonificationModel(length){
        var points = [];

        var maxLength = Math.min(length, studentModel.length)
        
        for (var i = 0; i < maxLength; i++){
            var otolith = studentModel[i];
            var point = {}; 
            // point.x = otolith.age;
            // point.y = Number(Text.get(otolith.length));

            var otolithPoint = otolith.pointLocation;
            if (otolithPoint.x !== -1){
                point.x = otolithPoint.x * plotScale.x;
                point.y = (1 - otolithPoint.y) * plotScale.y;

                if (point.x < 0){
                    point.x = 0;
                }
                points.push(point);
            }
        }

        return points;
    },

    getExpertModel(){
        return expertModel;
    },
    getFullSonificationModel(){
        var points = [];
        
        for (var i = 0; i < expertModel.length; i++){
            var otolith = expertModel[i];
            var point = {};
            point.x = otolith.age;
            point.y = otolith.length;
            points.push(point); 
        }

        return points;
    },
    resetTrends(){
        trendDrawing = "";
        currentTrend = null;
    },
    getTrendDrawing(){
        return trendDrawing;
    },
    setTrendDrawing(image){
        trendDrawing = image;
    },

    getCurrentTrend(){
        return currentTrend;
    },
    setCurrentTrend(model){
        currentTrend = model;
    },

    updateAge(index, age){
        if (index < studentModel.length){
            studentModel[index].age = age;
        }
    },

    updateOtolithTracingImage(index, image){
        if (image !== null){
            if (index < studentModel.length){
                studentModel[index].tracingImage = image;
            }
        }
    },

    updatePointLocation(index, x, y){
        if (index < studentModel.length){
            studentModel[index].pointLocation.x = x;
            studentModel[index].pointLocation.y = y;
        }
    },

    getTrendModel(){
        return trendModel;
    },

    
    getExpertOtolith(index){
        if (index < expertModel.length){
            return expertModel[index];
        }
        return null;
    },

    /**
     * @description gets otolith model
     * @param index of desired otolith
     * @returns otolith object
     */
    getStudentOtolith(index){
        if (index < studentModel.length){
            return studentModel[index];
        }
        return null;
    },

    /**
     * @returns all otolith models
     */
    getStudentModel(){
        return studentModel;
    },
    
    /**
     * @returns total count of otolith models
     */
    total(){
        return studentModel.length;
    },

    /**
     * @description updates studentModel with tracing image
     * @param index of current layer, image to be added to that layer
     */
    updateTracingImage(index, image){
        if (index < studentModel.length){
            studentModel[index].tracingImage = image;
        }
    },

    /**
     * @description resets all the tracing images in studentModel so otolith activity can be restarted
     */
    resetTracingLayers(){
        // for (var i = 0; i < studentModel.length; i++){
        //     studentModel[i].tracingImage = "";
        // }
    },
    hydrateExpertData(data){
        var status = new Status();
        var model = [];
        

        for (var i = 0; i < data.length; i++){
            status = this.hydrateExpertEntry(data[i], status);

            if (!status.success){
                return status;
            }

            status.result.index = i;

            model.push(status.result);
        }

        expertModel = model;

        status.success = true;
        status.result = model;
        return status;
    },

    hydrateExpertEntry(data, status) {
        var model = {};

        if (typeof data !== "object"){
            status.message = "ERROR: expert otolith data entry is not an object";
            return status;
        }

        if (typeof data["age"] === "number"){
            model.age = data["age"];
        }
        else{
            status.message = "ERROR: expert otolith data field 'age' malformatted or missing";
            return status;
        }

        if (typeof data["tag"] === "string"){
            model.tag = data["tag"];
        }
        else{
            status.message = "ERROR: expert otolith data 'tag' malformatted or missing";
            return status;
        }

        if (typeof data["length"] === "number"){
            model.length = data["length"];
        }
        else{
            status.message = "ERROR: expert otolith data field 'length' malformatted or missing";
            return status;
        }


        status.success = true;
        status.result = model;
        return status;
    }
}